interface PageRequestMessageJson {
  page_id: string;
  meta?: Record<string, string>;
  request: number;
  complete: boolean;
}

export default class PageRequest {
  readonly id: string;

  readonly meta: Record<string, string> | undefined;

  readonly request: number;

  readonly complete: boolean;

  constructor(
    id: string,
    meta: Record<string, string> | undefined,
    request: number,
    complete: boolean,
  ) {
    this.id = id;
    this.meta = meta;
    this.request = request;
    this.complete = complete;
  }

  public toJson(): PageRequestMessageJson {
    return {
      page_id: this.id,
      meta: this.meta,
      request: this.request,
      complete: this.complete,
    };
  }

  public static isPageRequest(data: Record<string, any>): boolean {
    return !!data.page_id && data.complete !== undefined && data.request !== undefined;
  }

  public static from(data: Record<string, any>): PageRequest | undefined {
    if (this.isPageRequest(data)) {
      const request = data as PageRequestMessageJson;
      return new PageRequest(request.page_id, request.meta, request.request, request.complete);
    }
    return undefined;
  }
}
